import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { refreshCompany, copyrightLine } from "@/lib/company";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";

const FIELDS = [
  ["legal_name", "Nome legal", "Aparece no rodapé, nos Termos, Privacidade, Devolução, checkout, Recibos e emails"],
  ["short_name", "Nome curto", "Ex.: \"GestaCV · Tavares Groupe\" no painel e no registo"],
  ["product_name", "Nome do produto", ""],
  ["nif", "NIF", ""],
  ["address", "Morada da sede", "Mostrada como \"<morada>, Cabo Verde\""],
  ["email", "Email de contacto", "Vazio = contacto@gestacv.cv"],
  ["phone", "Telefone de apoio (também WhatsApp)", "Aparece no Recibo, nos emails e nas páginas legais"],
];

export default function PlatformCompany() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const [test, setTest] = useState(null);
  const sendTest = async () => {
    setTest({ busy: true });
    try { const { data } = await api.post("/platform/email/test"); setTest(data); toast.success(`Email de teste enviado para ${data.to}`); }
    catch (err) { toast.error(apiError(err)); setTest(null); }
  };
  useEffect(() => { api.get("/platform/company").then((r) => setF(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!f) return <div className="flex h-64 items-center justify-center"><CircleNotch size={28} className="animate-spin text-primary" /></div>;
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/platform/company", f);
      setF(data); refreshCompany();
      toast.success("Dados da empresa guardados");
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-3xl space-y-6" data-testid="platform-company-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Button variant="outline" size="icon" className="rounded-full" asChild><Link to="/plataforma"><ArrowLeft size={18} /></Link></Button>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Super-admin</p>
            <h1 className="font-display text-3xl font-extrabold tracking-tight">Dados da empresa</h1>
          </div>
        </div>
        <Button className="rounded-full" onClick={save} disabled={busy} data-testid="save-company-btn">{busy ? <CircleNotch className="animate-spin" /> : "Guardar"}</Button>
      </div>
      <section className="grid gap-4 rounded-xl border border-border bg-card p-5 sm:grid-cols-2">
        {FIELDS.map(([k, label, hint]) => (
          <div key={k} className={`space-y-1.5 ${k === "legal_name" ? "sm:col-span-2" : ""}`}>
            <Label>{label}</Label>
            <Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`company-${k}`} />
            {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
          </div>
        ))}
      </section>
      <section className="space-y-3 rounded-xl border border-border bg-card p-5 text-sm" data-testid="email-test-section">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="font-display text-lg font-bold">Envio de emails</h2>
            <p className="text-muted-foreground">Remetente: GestaCV &lt;nao-responder@gestacv.cv&gt; · Reply-To: {f.email || "contacto@gestacv.cv"}</p>
          </div>
          <Button variant="outline" className="rounded-full" onClick={sendTest} disabled={test?.busy} data-testid="send-test-email-btn">
            {test?.busy ? <CircleNotch className="animate-spin" /> : "Enviar email de teste"}
          </Button>
        </div>
        {test?.via && (
          <p className={test.via === "resend" ? "text-success" : "text-amber-800"} data-testid="email-test-result">
            {test.via === "resend" ? `Enviado a partir de ${test.from} — domínio gestacv.cv verificado.`
              : `Enviado pelo remetente da plataforma (domínio gestacv.cv ainda não verificado no Resend): ${test.resend_error || ""}`}
          </p>
        )}
      </section>
      <section className="rounded-xl border border-dashed border-border bg-card p-5 text-sm" data-testid="company-preview">
        <div className="mb-1 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Pré-visualização do rodapé</div>
        {copyrightLine(f)}
      </section>
    </div>
  );
}
